// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import "./SearchButton.css";

// function SearchButton() {
//   const [isOpen, setIsOpen] = useState(false);

//   const searchRef = useRef(null);

//   // ===============================
//   // Static Search Data
//   // Backend Developer API Replace
//   // ===============================
//   const searchData = [

//   ];

//   const filteredResults = searchData.filter((item) =>
//     item.title.toLowerCase().includes(searchTerm.toLowerCase()),
//   );

//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (searchRef.current && !searchRef.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     function esc(e) {
//       if (e.key === "Escape") {
//         setIsOpen(false);
//       }
//     }

//     document.addEventListener("keydown", esc);

//     return () => document.removeEventListener("keydown", esc);
//   }, []);

//   const [searchOpen, setSearchOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredResults, setFilteredResults] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const getSearch = async (keyword) => {
//     try {
//       setLoading(true);

//       const response = await axios.get(
//         `${API_URL}/search/get/?keyword=${keyword}`,
//       );

//       // console.log("Search Response:", response.data);

//       setFilteredResults(response?.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching search results:", error);
//       setFilteredResults([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Add New Sticky Scroll Function
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 10) {
//         setIsSticky(true);
//       } else {
//         setIsSticky(false);
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   // Debounce Search
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (searchTerm.trim()) {
//         getSearch(searchTerm);
//       } else {
//         setFilteredResults([]);
//       }
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [searchTerm]);
//   return (
//     <div className="footer-search" ref={searchRef}>
//       <button
//         className={`footer-search-toggle-btn ${isOpen ? "active" : ""}`}
//         onClick={() => {
//           if (isOpen) {
//             setSearchTerm("");
//           }

//           setIsOpen(!isOpen);
//         }}
//       >
//         {isOpen ? (
//           <i className="fa-solid fa-xmark"></i>
//         ) : (
//           <i className="fa-solid fa-magnifying-glass"></i>
//         )}
//       </button>
//       <div
//         className={`footer-search-modal ${isOpen ? "footer-show-search" : ""}`}
//       >
//         <div className="searching-content-area">
//           <div className="search-input-box">
//             <input
//               type="text"
//               placeholder="Search here..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <i className="fa-solid fa-search searching-fixed-icon"></i>
//           </div>

//           <div className="search-data-result">
//             {searchTerm.length > 0 ? (
//               filteredResults.length > 0 ? (
//                 filteredResults.map((item) => (
//                   <Link
//                     key={item.id}
//                     to={item.url}
//                     className="search-item"
//                     onClick={() => {
//                       setIsOpen(false);
//                       setSearchTerm("");
//                     }}
//                   >
//                     <div className="search-icon">
//                       <i className="fa-solid fa-file-lines"></i>
//                     </div>

//                     <div className="search-content">
//                       <h6>{item.title}</h6>
//                       <span>{item.category}</span>
//                     </div>

//                     <i className="fa-solid fa-arrow-right"></i>
//                   </Link>
//                 ))
//               ) : (
//                 <div className="searching-empty-data">
//                   <h5 className="no-result-title m-0">No Results Found</h5>
//                   <p className="m-0">Try another keyword.</p>
//                 </div>
//               )
//             ) : null}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SearchButton;

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import "./SearchButton.css";

function SearchButton() {
  const API_URL = process.env.REACT_APP_API_URL;

  const { lang } = useLanguage();

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchRef = useRef(null);

  // Search API
  const getSearch = async (keyword) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_URL}/search/get/?keyword=${keyword}`,
      );

      setFilteredResults(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching search results:", error);
      setFilteredResults([]);
    } finally {
      setLoading(false);
    }
  };

  // Debounce Search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm.trim()) {
        getSearch(searchTerm);
      } else {
        setFilteredResults([]);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Close Outside Click
  useEffect(() => {
    function handleClickOutside(e) {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ESC Close
  useEffect(() => {
    function esc(e) {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    }

    document.addEventListener("keydown", esc);

    return () => {
      document.removeEventListener("keydown", esc);
    };
  }, []);

  // Limit Words
  const limitWords = (text, limit = 8) => {
    if (!text) return "";

    const clean = String(text)
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const words = clean.split(" ");

    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : clean;
  };

  return (
    <div className="footer-search" ref={searchRef}>
      <button
        className={`footer-search-toggle-btn ${isOpen ? "active" : ""}`}
        onClick={() => {
          if (isOpen) {
            setSearchTerm("");
            setFilteredResults([]);
          }

          setIsOpen(!isOpen);
        }}
      >
        {isOpen ? (
          <i className="fa-solid fa-xmark"></i>
        ) : (
          <i className="fa-solid fa-magnifying-glass"></i>
        )}
      </button>

      <div
        className={`footer-search-modal ${isOpen ? "footer-show-search" : ""}`}
      >
        <div className="searching-content-area">
          <div className="search-input-box">
            <input
              type="text"
              placeholder="Search here..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <i className="fa-solid fa-search searching-fixed-icon"></i>
          </div>

          <div className="search-data-result">
            {searchTerm.trim() !== "" && (
              <>
                {loading ? (
                  <div className="searching-empty-data">
                    <h5 className="m-0">Searching...</h5>
                  </div>
                ) : filteredResults.length > 0 ? (
                  filteredResults.map((item, index) => (
                    <Link
                      key={index}
                      to={item?.url}
                      className="search-item"
                      onClick={() => {
                        setIsOpen(false);
                        setSearchTerm("");
                        setFilteredResults([]);
                      }}
                    >
                      <div className="search-icon">
                        <i className="fa-solid fa-file-lines"></i>
                      </div>

                      <div className="search-content">
                        <h6>
                          {limitWords(
                            item?.title?.[lang] ||
                              item?.title?.en ||
                              item?.title,
                            8,
                          )}
                        </h6>

                        <span>{item?.type || "Page"}</span>
                      </div>

                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  ))
                ) : (
                  <div className="searching-empty-data">
                    <h5 className="no-result-title m-0">No Results Found</h5>

                    <p className="m-0">Try another keyword.</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchButton;
